(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["delivery_check"] && !Shopify.designMode) return;
  try {
    const STORAGE_METHOD_KEY = 'method';
  const STORAGE_POSTCODE_KEY = 'postcode';

  /**
   * @typedef {{ rate: number, formatted: string, postcodes: string[] }} DeliveryZone
   * @typedef {{ success: string, errorHtml: string, incomplete: string, pickupNote: string }} DeliveryMessages
   */

  class DeliveryCheck extends HTMLElement {
    /** @type {AbortController | null} */
    #abortController = null;

    /** @type {boolean} */
    #unlocked = false;

    /** @type {Map<string, DeliveryZone>} */
    #postcodeMap = new Map();

    /** @type {DeliveryMessages | null} */
    #messages = null;

    connectedCallback() {
      this.#abortController?.abort();
      this.#abortController = new AbortController();
      const { signal } = this.#abortController;

      this.#postcodeMap = this.#buildPostcodeMap();
      this.#messages = this.#readMessages();

      const deliveryRadio = this.querySelector('[ref="deliveryRadio"]');
      const pickupRadio = this.querySelector('[ref="pickupRadio"]');
      const postcodeInput = this.querySelector('[ref="postcodeInput"]');
      const checkButton = this.querySelector('[ref="checkButton"]');

      if (deliveryRadio instanceof HTMLInputElement) {
        deliveryRadio.addEventListener('change', () => this.#onMethodChange('delivery'), { signal });
      }

      if (pickupRadio instanceof HTMLInputElement) {
        pickupRadio.addEventListener('change', () => this.#onMethodChange('pickup'), { signal });
      }

      if (postcodeInput instanceof HTMLInputElement) {
        postcodeInput.addEventListener(
          'input',
          () => {
            this.#onPostcodeInput(postcodeInput);
          },
          { signal }
        );
        postcodeInput.addEventListener(
          'keydown',
          (event) => {
            if (event.key !== 'Enter') return;

            event.preventDefault();
            this.#checkPostcode();
          },
          { signal }
        );
      }

      if (checkButton instanceof HTMLButtonElement) {
        checkButton.addEventListener(
          'click',
          () => {
            this.#checkPostcode();
          },
          { signal }
        );
      }

      document.addEventListener(
        'click',
        (event) => {
          this.#onDocumentClick(event);
        },
        { capture: true, signal }
      );
      document.addEventListener(
        'submit',
        (event) => {
          this.#onDocumentSubmit(event);
        },
        { capture: true, signal }
      );
      document.addEventListener(
        'variant:update',
        () => {
          this.#syncAddToCartDisabled();
        },
        { signal }
      );

      this.#lockAddToCart();
      this.#restoreSession();
    }

    disconnectedCallback() {
      this.#abortController?.abort();
      this.#abortController = null;
    }

    /**
     * @returns {Map<string, DeliveryZone>}
     */
    #buildPostcodeMap() {
      const map = new Map();
      const dataEl = this.querySelector('[ref="zonesData"]');

      if (!(dataEl instanceof HTMLScriptElement) || dataEl.textContent == null) {
        return map;
      }

      try {
        const zones = JSON.parse(dataEl.textContent);

        if (!Array.isArray(zones)) return map;

        for (const zone of zones) {
          if (!zone || !Array.isArray(zone.postcodes)) continue;

          for (const raw of zone.postcodes) {
            const code = this.#normalizePostcode(String(raw));

            if (code) {
              map.set(code, zone);
            }
          }
        }
      } catch (error) {
        console.error('[delivery-check] Failed to parse zone data', error);
      }

      return map;
    }

    /**
     * @returns {DeliveryMessages | null}
     */
    #readMessages() {
      const dataEl = this.querySelector('[ref="messagesData"]');

      if (!(dataEl instanceof HTMLScriptElement) || dataEl.textContent == null) {
        return null;
      }

      try {
        return JSON.parse(dataEl.textContent);
      } catch (error) {
        console.error('[delivery-check] Failed to parse messages', error);
        return null;
      }
    }

    /**
     * @param {'delivery' | 'pickup'} method
     * @param {{ restore?: boolean }} [options]
     */
    #onMethodChange(method, options = {}) {
      const restore = Boolean(options.restore);
      const postcodePanel = this.querySelector('[ref="postcodePanel"]');

      if (postcodePanel instanceof HTMLElement) {
        postcodePanel.hidden = method !== 'delivery';
      }

      if (method === 'pickup') {
        this.#setAttributes('Pickup', '', '');
        this.#showStatus(this.#messages?.pickupNote || '', 'success');
        this.#setUnlocked(true);
        this.#writeSession('pickup', '');
        return;
      }

      this.#clearStatus();
      this.#setAttributes('', '', '');
      this.#setUnlocked(false);
      this.#writeSession('delivery', this.#currentPostcode());

      const postcodeInput = this.querySelector('[ref="postcodeInput"]');

      if (!restore && postcodeInput instanceof HTMLInputElement) {
        postcodeInput.focus();
      }
    }

    /**
     * @param {HTMLInputElement} input
     */
    #onPostcodeInput(input) {
      const digits = input.value.replace(/\D/g, '').slice(0, 4);
      input.value = digits;
      input.removeAttribute('aria-invalid');
      this.#clearStatus();
      this.#setAttributes('Delivery', '', '');
      this.#setUnlocked(false);
      this.#writeSession('delivery', digits);
    }

    #checkPostcode() {
      const messages = this.#messages;
      const code = this.#currentPostcode();
      const input = this.querySelector('[ref="postcodeInput"]');

      if (!(input instanceof HTMLInputElement) || !messages) return;

      if (code.length !== 4) {
        input.setAttribute('aria-invalid', 'true');
        this.#showStatus(messages.incomplete, 'error');
        this.#setUnlocked(false);
        return;
      }

      const zone = this.#postcodeMap.get(code);

      if (!zone) {
        input.setAttribute('aria-invalid', 'true');
        this.#showStatus(messages.errorHtml, 'error', true);
        this.#setAttributes('Delivery', code, '');
        this.#setUnlocked(false);
        return;
      }

      input.setAttribute('aria-invalid', 'false');
      const success = messages.success.replace('[postcode]', code).replace('[amount]', zone.formatted);
      this.#showStatus(success, 'success');
      this.#setAttributes('Delivery', code, zone.formatted);
      this.#setUnlocked(true);
      this.#writeSession('delivery', code);
    }

    /**
     * @returns {string}
     */
    #currentPostcode() {
      const input = this.querySelector('[ref="postcodeInput"]');

      if (!(input instanceof HTMLInputElement)) return '';

      return this.#normalizePostcode(input.value);
    }

    /**
     * @param {string} value
     * @returns {string}
     */
    #normalizePostcode(value) {
      return value.replace(/\D/g, '').slice(0, 4);
    }

    /**
     * @param {string} method
     * @param {string} postcode
     * @param {string} rate
     */
    #setAttributes(method, postcode, rate) {
      const methodAttr = this.querySelector('[ref="methodAttr"]');
      const postcodeAttr = this.querySelector('[ref="postcodeAttr"]');
      const rateAttr = this.querySelector('[ref="rateAttr"]');

      if (methodAttr instanceof HTMLInputElement) methodAttr.value = method;
      if (postcodeAttr instanceof HTMLInputElement) postcodeAttr.value = postcode;
      if (rateAttr instanceof HTMLInputElement) rateAttr.value = rate;
    }

    /**
     * @param {string} message
     * @param {'error' | 'success'} type
     * @param {boolean} [asHtml]
     */
    #showStatus(message, type, asHtml = false) {
      const status = this.querySelector('[ref="status"]');

      if (!(status instanceof HTMLElement)) return;

      status.hidden = false;
      status.classList.toggle('delivery-check__status--error', type === 'error');
      status.classList.toggle('delivery-check__status--success', type === 'success');

      if (asHtml) {
        status.innerHTML = message;
      } else {
        status.textContent = message;
      }
    }

    #clearStatus() {
      const status = this.querySelector('[ref="status"]');

      if (!(status instanceof HTMLElement)) return;

      status.hidden = true;
      status.textContent = '';
      status.classList.remove('delivery-check__status--error', 'delivery-check__status--success');
    }

    /**
     * @param {boolean} unlocked
     */
    #setUnlocked(unlocked) {
      this.#unlocked = unlocked;
      this.#syncAddToCartDisabled();
    }

    /**
     * @returns {HTMLFormElement | null}
     */
    #getProductForm() {
      const formId = this.dataset.formId;

      if (!formId) return null;

      const form = document.getElementById(formId);

      return form instanceof HTMLFormElement ? form : null;
    }

    #lockAddToCart() {
      this.#unlocked = false;
      this.#syncAddToCartDisabled();
    }

    #syncAddToCartDisabled() {
      const form = this.#getProductForm();

      if (!form) {
        requestAnimationFrame(() => {
          const retry = this.#getProductForm();

          if (retry) this.#applyDisabledState(retry);
        });
        return;
      }

      this.#applyDisabledState(form);
    }

    /**
     * @param {HTMLFormElement} form
     */
    #applyDisabledState(form) {
      const buttons = form.querySelectorAll('button[type="submit"], input[type="submit"]');

      for (const button of buttons) {
        if (!(button instanceof HTMLButtonElement) && !(button instanceof HTMLInputElement)) continue;

        button.disabled = !this.#unlocked;
      }
    }

    /**
     * @param {Event} event
     */
    #onDocumentClick(event) {
      if (this.#unlocked) return;
      if (!(event.target instanceof Element)) return;

      const form = this.#getProductForm();

      if (!form) return;

      const submitButton = event.target.closest('button[type="submit"], input[type="submit"]');

      if (!submitButton || !form.contains(submitButton)) return;

      event.preventDefault();
      event.stopPropagation();
      this.#focusGate();
    }

    /**
     * @param {Event} event
     */
    #onDocumentSubmit(event) {
      if (this.#unlocked) return;

      const form = this.#getProductForm();

      if (!form || event.target !== form) return;

      event.preventDefault();
      event.stopPropagation();
      this.#focusGate();
    }

    #focusGate() {
      const pickupRadio = this.querySelector('[ref="pickupRadio"]');
      const postcodeInput = this.querySelector('[ref="postcodeInput"]');
      const postcodePanel = this.querySelector('[ref="postcodePanel"]');

      if (postcodePanel instanceof HTMLElement && !postcodePanel.hidden && postcodeInput instanceof HTMLInputElement) {
        postcodeInput.focus();
        return;
      }

      if (pickupRadio instanceof HTMLInputElement) {
        pickupRadio.focus();
      }
    }

    #restoreSession() {
      const stored = this.#readSession();

      if (!stored) return;

      if (stored.method === 'pickup') {
        const pickupRadio = this.querySelector('[ref="pickupRadio"]');

        if (pickupRadio instanceof HTMLInputElement) {
          pickupRadio.checked = true;
          this.#onMethodChange('pickup', { restore: true });
        }

        return;
      }

      if (stored.method !== 'delivery') return;

      const deliveryRadio = this.querySelector('[ref="deliveryRadio"]');
      const postcodeInput = this.querySelector('[ref="postcodeInput"]');

      if (deliveryRadio instanceof HTMLInputElement) {
        deliveryRadio.checked = true;
        this.#onMethodChange('delivery', { restore: true });
      }

      if (stored.postcode && postcodeInput instanceof HTMLInputElement) {
        postcodeInput.value = stored.postcode;
        this.#checkPostcode();
      }
    }

    /**
     * @param {'delivery' | 'pickup'} method
     * @param {string} postcode
     */
    #writeSession(method, postcode) {
      try {
        const key = this.dataset.storageKey || 'delivery-check';
        sessionStorage.setItem(
          key,
          JSON.stringify({
            [STORAGE_METHOD_KEY]: method,
            [STORAGE_POSTCODE_KEY]: postcode,
          })
        );
      } catch {
        // Private mode or blocked storage
      }
    }

    /**
     * @returns {{ method: string, postcode: string } | null}
     */
    #readSession() {
      try {
        const key = this.dataset.storageKey || 'delivery-check';
        const raw = sessionStorage.getItem(key);

        if (!raw) return null;

        const parsed = JSON.parse(raw);

        return {
          method: String(parsed[STORAGE_METHOD_KEY] || ''),
          postcode: this.#normalizePostcode(String(parsed[STORAGE_POSTCODE_KEY] || '')),
        };
      } catch {
        return null;
      }
    }
  }

  if (!customElements.get('delivery-check')) {
    customElements.define('delivery-check', DeliveryCheck);
  }
  } catch(e) { console.error(e); }
})();

})();
